import {AuwBaseComponent} from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";

export class AuwTwoClickVideo extends AuwBaseComponent{

    constructor($el){
        super($el);

        this.config = {
            controls : 0,
            autoplay : 0
        }

    }

    __PageReady(){
        this.loadButton = this.$el.find('.loadButton')
        this.loadButton.on("click",() => {this.loadButtonClicked();});
    }



    loadButtonClicked(e){
        this.$el.parents('.embed-responsive').removeClass('poster-not-clicked');
        switch(this.config.provider){
            case "youtube"  : this.injectYoutube();break;
            case "vimeo"    : this.injectVimeo();break;

        }
    }

    injectYoutube(){
        var url = "https://www.youtube-nocookie.com/embed/"+this.config.videoId+"?showinfo=0&rel=0&autoplay="+this.config.autoplay+"&controls="+this.config.controls;
        this.$el.replaceWith(this.getIframe(url));
    }

    injectVimeo(){
        var url = "https://player.vimeo.com/video/"+this.config.videoId+"?dnt=1&autoplay="+this.config.autoplay;
        this.$el.replaceWith(this.getIframe(url));
    }



    getIframe(url){
        return "<iframe frameborder='0' webkitallowfullscreen mozallowfullscreen allowfullscreen src='"+url+"'></iframe>";
    }

}
